import { create } from 'zustand'

export type PlanFinderSource = 'plans-banner'

interface PlanFinderDialogStore {
  isOpen: boolean
  source: PlanFinderSource | null
  openDialog: (source: PlanFinderSource) => void
  closeDialog: () => void
  setIsOpen: (open: boolean) => void
}

export const usePlanFinderDialogStore = create<PlanFinderDialogStore>(
  (set) => ({
    isOpen: false,
    source: null,
    openDialog: (source: PlanFinderSource) => set({ isOpen: true, source }),
    closeDialog: () => set({ isOpen: false, source: null }),
    setIsOpen: (open: boolean) => set({ isOpen: open }),
  }),
)
